import React from 'react';
import Treasure from 'views/MathClub2023/Treasure';

const MathClubPage = () => {
  return <Treasure/>;
};

export default MathClubPage;

